var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    "aria-label": "Door blocked",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.537,
    y: 1.9063,
    width: 24.061,
    height: 46.726,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.8599
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.239,
    y: 5.6444,
    width: 16.657,
    height: 42.988,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.3949
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.195,
    cy: 27.138,
    rx: 1.2956,
    ry: 1.3083,
    style: {
      strokeWidth: 0.46498
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.9848 3.7754 42.569 42.988",
    stroke: "#d40000",
    strokeLinecap: "round",
    strokeWidth: 4.6498
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m46.554 3.7754-42.569 42.988",
    stroke: "#d40000",
    strokeLinecap: "round",
    strokeWidth: 4.6498
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocco);
export default __webpack_public_path__ + "static/media/blocco.429ea911607966194ae083ca45250516.svg";
export { ForwardRef as ReactComponent };